import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import escalationHistoryApi from 'api/escalationHistoryApi';

export const fetchEscalationHistory = createAsyncThunk(
  'escalationHistory/fetchAll',
  async ({ page = 1, pageSize = 10, search = '', escalatedFrom }, { rejectWithValue }) => {
    try {
      const res = await escalationHistoryApi.getAll(page, pageSize, search,escalatedFrom);
      return res;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to load escalation history');
    }
  }
);

const escalationHistorySlice = createSlice({
  name: 'escalationHistory',
  initialState: {
    list: [],
    pagination: { count: 0, page_size: 10, next: null, previous: null },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEscalationHistory.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchEscalationHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload.data || [];
        state.pagination = action.payload.pagination || {};
      })
      .addCase(fetchEscalationHistory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = escalationHistorySlice.actions;
export default escalationHistorySlice.reducer;